import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Cardápio",
  path: "/merenda/mercardapio",
  name: "mercardapio",
  component: () => import("@/views/merenda/mercardapio/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.CARDAPIONOVO_MENU_1000200399],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Cardápio",
  path: "/merenda/mercardapio/cadastro/:id?",
  parent: "mercardapio",
  name: "mercardapio_create",
  component: () => import("@/views/merenda/mercardapio/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.CARDAPIONOVO_MENU_1000200399],
  },
  goesToMenu: true,
 },
];
